import React from 'react';
import utilsHolder from './utilsHolder';

class Moment extends React.Component {

    render () {
        const props = this.props;
        const { date, format, isUtc } = props;
        const formattedDate = Moment.getFormattedDate(date, format, isUtc);

        return <time dateTime={date}> {formattedDate}</time>;
    }

    static getMoment () {
        const { momentTz } = utilsHolder;
        return momentTz ? momentTz.getMomentTimezone() : null;
    }

    static getFormattedDate (date, format, isUtc) {
        const { momentTz } = utilsHolder;

        if (!momentTz) {
            return null;
        }

        const moment = momentTz.getMomentTimezone();
        return isUtc ? moment.utc(date).format(format) : moment(date).format(format);
    }
}

export default Moment;
